import { ajax, } from '../twd'

let orders = {
    corp: ['corp', 'tsy', 'muni_in', 'muni_out'],
    muni_in: ['muni_in', 'muni_out', 'corp', 'tsy'],
    muni_out: ['muni_out', 'muni_in', 'corp', 'tsy'],
    tsy: ['tsy', 'corp', 'muni_in', 'muni_out'],
}

export const getStateTaxRate = ({taxState, customTaxRate}) => {
    return taxState==='OTHER'
        ? parseFloat(customTaxRate)/100.0
        : parseFloat((global.app.config.state_tax_rates || {})[taxState] || 0)
}

export const calculate = async (values) => {
    let {bondProductType, bondYield, federalTaxRate, } = values
    let yld = parseFloat(bondYield) / 100.0
    let fed = parseFloat(federalTaxRate)
    let st = getStateTaxRate(values)

    if ( isNaN(yld) || isNaN(fed) || isNaN(st)) return null

    let { data } = await ajax({
        url: '/esb/retailservice/teyCalculatorService/getTeyCalculations',
        method: 'POST',
        body: JSON.stringify({
            bondProductType,
            noOfVariance: 3,
            variance: 0.05,
            bondYield: yld * 100.0,
            federalTaxRate: fed * 100.0,
            stateTaxRate: st * 100.0,
        })
    })

    let val = (((await data) || {}).values || [])
        .map(r => {
            for (let k in r) {
                r[k] /= 100.0
            }
            return r
        })
        .sort( (a,b) => {
            return b[bondProductType] - a[bondProductType]
        })

    if (val.length===0) {
        throw new Error("Unable to calculate")
    }

    return {
        values: val,
        order: orders[bondProductType],
        fedTax: fed,
        stateTax: st,
        totalTax: fed + st
    }
}
